import React, { useState } from "react";
import { object, string, array } from "yup";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Space, Input, Button } from "@masterteam/mt-design-react";

import { WizardStep } from "../Wizard";
import NewTable from "../../NewTable";

import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";

export const resultsValidationSchema = object().shape({
  ObjectiveResults: array()
    .of(
      object().shape({
        ArabicName: string().required(" "),
        EnglishName: string().required(" "),
      })
    )
    .min(1, " "),
});

function Results({ formBag }) {
  const intl = useIntl();
  const { values, setFieldValue } = formBag;
  const [arabicName, setArabicName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <WizardStep name="Results">
      <Space direction="vertical" size="medium" className="results-container">
        <Space>
          <Space direction="vertical" style={{ flex: 1 }}>
            <FormattedMessage id="objective.arabic-result" />
            <Input
              placeholder={intl.formatMessage({
                id: "objective.arabic-result",
              })}
              value={arabicName}
              error={!values.ObjectiveResults?.length && !arabicName}
              onChange={(event) => {
                setArabicName(event.target.value);
              }}
            />
          </Space>

          <Space direction="vertical" style={{ flex: 1 }}>
            <FormattedMessage id="objective.english-result" />
            <Input
              placeholder={intl.formatMessage({
                id: "objective.english-result",
              })}
              value={englishName}
              error={!values.ObjectiveResults?.length && !englishName}
              onChange={(event) => {
                setEnglishName(event.target.value);
              }}
            />
          </Space>
        </Space>
        <Row>
          <Button
            disabled={!englishName || !arabicName}
            variant="primary"
            className="add-button"
            onClick={() => {
              const data = [...values?.ObjectiveResults];

              const body = {
                ArabicName: arabicName,
                EnglishName: englishName,
                index: selectedItem?.index || data?.length + 1,
              };

              if (selectedItem) {
                const index = data.findIndex(
                  (e) => e.index === selectedItem?.index
                );

                data[index] = body;
              } else {
                data.push(body);
              }

              setFieldValue("ObjectiveResults", data);
              setSelectedItem(null);
              setEnglishName("");
              setArabicName("");
            }}
          >
            {intl.formatMessage({
              id: selectedItem ? "common.update" : "common.add",
            })}
          </Button>
        </Row>

        <NewTable
          data={values?.ObjectiveResults || []}
          actionsHeader={null}
          columns={[
            {
              key: "Arabic Name",
              header: intl.formatMessage({
                id: "objective.arabic-result",
              }),
              cell: (item) => item.ArabicName,
              width: "50%",
            },
            {
              key: "English Name",
              header: intl.formatMessage({
                id: "objective.english-result",
              }),
              cell: (item) => item.EnglishName,
              width: "50%",
            },
          ]}
          actions={[
            {
              key: "edit",
              variant: "primary",
              Icon: EditIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.update" }),
              onClick: (item) => {
                setSelectedItem(item);
                setArabicName(item?.ArabicName);
                setEnglishName(item?.EnglishName);
              },
            },
            {
              key: "delete",
              variant: "error",
              Icon: DeleteIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.delete" }),
              disabled: (item) => item?.index === selectedItem?.index,
              onClick: (item) => {
                const data = values.ObjectiveResults?.filter(
                  (e) => e.index !== item.index
                );

                setFieldValue("ObjectiveResults", data);
              },
            },
          ]}
          compact
        />
      </Space>
    </WizardStep>
  );
}

export default Results;
